import { Schema } from '../../types'
import { commonColumns } from '../common_schema'

export const errorSchema: Schema = {
  title: 'Errors',
  level: 2,
  columns: commonColumns
}
